import { useEffect, useRef } from 'react';

export type TaskCollectionChangeReason = 'created' | 'deleted' | 'membership' | 'reconnected';

export interface TaskCollectionChange {
  key: string;
  reason: TaskCollectionChangeReason;
  taskId?: string;
}

type TaskCollectionChangeListener = (change: TaskCollectionChange) => void;

const listeners = new Set<TaskCollectionChangeListener>();
const pendingChanges = new Map<string, TaskCollectionChange>();

export const emitTaskCollectionChange = (change: TaskCollectionChange) => {
  pendingChanges.set(change.key, change);
  listeners.forEach((listener) => listener(change));
};

export const clearTaskCollectionChanges = () => pendingChanges.clear();

export const useTaskCollectionChanges = (onTaskCollectionChanged: TaskCollectionChangeListener) => {
  const listenerRef = useRef(onTaskCollectionChanged);

  useEffect(() => {
    listenerRef.current = onTaskCollectionChanged;
  }, [onTaskCollectionChanged]);

  useEffect(() => {
    const listener = (change: TaskCollectionChange) => listenerRef.current(change);

    listeners.add(listener);
    pendingChanges.forEach(listener);

    return () => {
      listeners.delete(listener);
    };
  }, []);
};
